import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'


  class NutritionAndNutritionalPlans extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        nutrition_and_nutritional_plans: []
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };
    }

    componentDidMount() {
        const { cookies } = this.props;
  
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
  
        axios.post(Backend_Url + 'getNutritionAndNutritionalPlans', data)
        .then((res) => {
            let result = res.data
            this.setState({nutrition_and_nutritional_plans: result})
        }).catch((error) => {
            console.log(error)
        })
    }




    render() {
        var nutrition_and_nutritional_plans = this.state.nutrition_and_nutritional_plans
        var nutrition_and_nutritional_plans_map = nutrition_and_nutritional_plans.map((item, index) => {
            return<Row style={{minHeight: '100px', width: '200px', margin: '5px', background: '#FFFFFF', boxShadow: '0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12)'}}>
                <Col style={{textAlign: 'left'}}>
                    <a href={'nutrition-and-nutritional-plans/' + item._id.$oid} style={{color: 'inherit'}}>
                        <img src={Backend_Url + 'media/' + item.image} style={{marginTop: '10px', width: '100%', borderTopLeftRadius: '20px', borderTopRightRadius: '20px'}}/>
                        <h5 style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
                            {item.name}
                        </h5>
                        <h5 style={{marginTop: '10px', fontSize: '16px', height: '18px', lineHeight: '18px', color: '#333', fontWeight: '700'}}>
                            {item.frequency} times a day
                        </h5>
                        <h6 style={{marginTop: '10px', marginBottom: '10px', color: '#333'}}>
                            {item.goals}
                        </h6>
                    </a>
                </Col>
            </Row>
        })

        if(nutrition_and_nutritional_plans.length == 0){
          return<div>
            <br/>
            <Row>
                <Col>
                    <h5 style={{marginTop: '60px', textAlign: 'center', marginBottom: '400px'}}>
                        No nutritional plans found.
                    </h5>
                </Col>
            </Row>
          </div>
        }

      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>NUTRITION AND NUTRITIONAL PLANS - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Row>
                {nutrition_and_nutritional_plans_map}
            </Row>
        </div>
      );
    }

  };
  
  export default withCookies(NutritionAndNutritionalPlans);